// extracted by mini-css-extract-plugin
export default {"container":"dcc_vatInclusionSwitch-container","button":"dcc_vatInclusionSwitch-button"};